import { useEffect } from 'react';
import { useParams, Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Loader } from '@link/gds-share/components';
import { Link } from '@linktivity/link-ui';
import { ROUTE_PATH } from '@link/gds-share/constants/path';
import { NEO_SUPPLIER_HOST } from '@link/gds-supplier/constants/env';
import { useBreadcrumb } from '@link/gds-supplier/hooks';
import { useStore } from '@link/gds-supplier/stores';
import Header from '../Header';
import Sidebar from './Sidebar';
import styles from './activity.module.css';

const ActivityLayout = () => {
  const { t } = useTranslation();
  const { activity, memo, breadcrumb, supplier } = useStore();
  const { setBreadcrumbRoutes } = useBreadcrumb(activity);
  const { activityId } = useParams();

  useEffect(() => {
    const routes = [
      {
        to: `/${ROUTE_PATH.activities}`,
        name: t('layouts.sidebar.activities')
      }
    ];
    setBreadcrumbRoutes(routes);

    return () => {
      breadcrumb.clear();
    };
  }, [breadcrumb, t, setBreadcrumbRoutes]);

  useEffect(() => {
    const fetchData = async () => {
      if (activityId) {
        activity.clearActivity();
        await activity.getActivity(activityId);
        if (activity.movedToNeo) return;
        await supplier.getActivitySupplier(activity.supplierId);
        memo.getMemo(activityId);
      }
    };
    fetchData();
  }, [activity, activityId, memo, supplier]);

  if (activity.movedToNeo) {
    const neoUrl = `${NEO_SUPPLIER_HOST}/activities/${activityId}/info`;
    return (
      <div className={styles.activity}>
        <Header />
        <div className={styles.moved}>
          <p>{t('layouts.activity.movedToNeo')}</p>
          <Link href={neoUrl}>{neoUrl}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.activity}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            {activity.loaded ? <Outlet /> : <Loader />}
          </div>
        </main>
      </div>
    </div>
  );
};
const ObserverActivityLayout = observer(ActivityLayout);
export default ObserverActivityLayout;
